import { render, staticRenderFns } from "./clientFundUseList.vue?vue&type=template&id=90e9ddba&scoped=true"
import script from "./clientFundUseList.vue?vue&type=script&lang=js"
export * from "./clientFundUseList.vue?vue&type=script&lang=js"
import style0 from "./clientFundUseList.vue?vue&type=style&index=0&id=90e9ddba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e9ddba",
  null
  
)

export default component.exports